var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisabledPrevIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7049 7.60983L14.2949 6.19983L8.29492 12.1998L14.2949 18.1998L15.7049 16.7898L11.1249 12.1998L15.7049 7.60983Z",
    fill: "#B0C9CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledPrevIcon);
export default __webpack_public_path__ + "static/media/disabled-prev-icon.2b854c2df662d2dd826427adde1274ca.svg";
export { ForwardRef as ReactComponent };